import Vue from 'vue'
import Router from 'vue-router'
import http from '@/utils/request'
import { isURL } from '@/utils/validate'

Vue.use(Router)
const agentMenu = {
  id: 'agent-management',
  name: '代理管理',
  icon: 'icon-team',
  children: [
    { id: 'agent-users', name: '代理用户', url: 'agent/users', icon: 'icon-user' },
    { id: 'agent-lines', name: '代理线路', url: 'agent/lines', icon: 'icon-link' },
    { id: 'agent-commissions', name: '返佣流水', url: 'agent/commissions', icon: 'icon-file' },
    { id: 'agent-withdraw-applies', name: '提现申请', url: 'agent/withdraw-applies', icon: 'icon-audit' },
    { id: 'agent-withdraw-records', name: '提现流水', url: 'agent/withdraw-records', icon: 'icon-file' },
    { id: 'agent-global-config', name: '全局设置', url: 'agent/global-config', icon: 'icon-setting' },
    { id: 'agent-receipts', name: '收款列表', url: 'agent/receipts', icon: 'icon-file' },
    { id: 'agent-exchange-rate', name: '汇率设置', url: 'agent/exchange-rate', icon: 'icon-setting' }
  ]
}

function mergeAgentMenu(menuList = []) {
  const list = menuList.filter(item => item.id !== agentMenu.id && item.name !== agentMenu.name)
  list.splice(Math.min(1, list.length), 0, agentMenu)
  return list
}
const ossRoute = {
  path: '/system/oss-config',
  component: () => import('@/views/main'),
  hidden: true,
  permissions: ['sys:oss:all'],
  children: [
    {
      path: 'index',
      component: () => import('@/views/modules/oss/config'),
      name: 'OssConfig',
      meta: { title: '配置管理', activeMenu: '/system/oss', isTab: true }
    }
  ]
};
// 页面路由(独立页面)
export const pageRoutes = [
  {
    path: '/404',
    component: () => import('@/views/pages/404'),
    name: '404',
    meta: { title: '404未找到' },
    beforeEnter(to, from, next) {
      // 拦截处理特殊业务场景
      // 如果, 重定向路由包含__双下划线, 为临时添加路由
      if (/__.*/.test(to.redirectedFrom)) {
        return next(to.redirectedFrom.replace(/__.*/, ''))
      }
      next()
    }
  },
  ossRoute,
  { path: '/login', component: () => import('@/views/pages/login'), name: 'login', meta: { title: '登录' } },

]

// 模块路由(基于主入口布局页面)
export const moduleRoutes = {
  path: '/',
  component: () => import('@/views/main'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: '主入口布局' },
  children: [
    { path: '/home', component: () => import('@/views/modules/home'), name: 'home', meta: { title: '首页', isTab: true } }
  ]
}

export function addDynamicRoute(routeParams, router) {
  // 组装路由名称, 并判断是否已添加, 如是: 则直接跳转
  var routeName = routeParams.routeName
  var dynamicRoute = window.SITE_CONFIG['dynamicRoutes'].filter(item => item.name === routeName)[0]

  if (dynamicRoute) {

    return router.push({ name: routeName, params: routeParams.params })
  }
  // 否则: 添加并全局变量保存, 再跳转
  dynamicRoute = {
    path: routeName,
    component: () => import(`@/views/modules/${routeParams.path}`).catch(err => {
      console.error(`Failed to load component: @/views/modules/${routeParams.path}`, err)
      return import('@/views/pages/404')
    }),
    name: routeName,
    meta: {
      ...window.SITE_CONFIG['contentTabDefault'],
      menuId: routeParams.menuId,
      title: `${routeParams.title}`
    }
  }
  router.addRoutes([
    {
      ...moduleRoutes,
      name: `main-dynamic__${dynamicRoute.name}`,
      children: [dynamicRoute]
    }
  ])
  window.SITE_CONFIG['dynamicRoutes'].push(dynamicRoute)
  router.push({ name: dynamicRoute.name, params: routeParams.params })
}

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: pageRoutes.concat(moduleRoutes)
})

router.beforeEach((to, from, next) => {
  // 添加动态(菜单)路由
  // 已添加或者当前路由为页面路由, 可直接访问
  if (window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] || fnCurrentRouteIsPageRoute(to, pageRoutes)) {
    return next()
  }


  // 获取字典列表, 添加并全局变量保存
  http.get('/sys/dict/type/all').then(({ data: res }) => {
    if (res.code !== 0) {
      return
    }
    window.SITE_CONFIG['dictList'] = res.data
  }).catch(() => { })
  // 获取菜单列表, 添加并全局变量保存
  http.get('/sys/menu/nav').then(({ data: res }) => {
    if (res.code !== 0) {
      Vue.prototype.$message.error(res.msg)
      return next({ name: 'login' })
    }
    window.SITE_CONFIG['menuList'] = mergeAgentMenu(res.data)
    fnAddDynamicMenuRoutes(window.SITE_CONFIG['menuList'])
    next({ ...to, replace: true })
  }).catch(() => {
    next({ name: 'login' })
  })
})

/**
 * 判断当前路由是否为页面路由
 * @param {*} route 当前路由
 * @param {*} pageRoutes 页面路由
 */
function fnCurrentRouteIsPageRoute(route, pageRoutes = []) {
  var temp = []
  for (var i = 0; i < pageRoutes.length; i++) {
    if (route.path === pageRoutes[i].path) {
      return true
    }
    if (pageRoutes[i].children && pageRoutes[i].children.length >= 1) {
      temp = temp.concat(pageRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteIsPageRoute(route, temp) : false
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {

  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
      continue
    }
    // 组装路由
    var route = {
      path: '',
      component: null,
      name: '',
      meta: {
        ...window.SITE_CONFIG['contentTabDefault'],
        menuId: menuList[i].id,
        title: menuList[i].name
      }
    }
    // eslint-disable-next-line
    let URL = (menuList[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      route['path'] = route['name'] = `i-${menuList[i].id}`
      route['meta']['iframeURL'] = URL
    } else {
      const originalURL = URL
      URL = URL.replace(/^\//, '').replace(/_/g, '-')
      console.log(`Processing route: ${menuList[i].name}, original URL: ${originalURL}, processed URL: ${URL}`)

      // 处理重复路径的情况，如 novel/novel -> novel/novel
      let componentPath = URL
      const parts = URL.split('/')
      if (parts.length === 2 && parts[0] === parts[1]) {
        // 如果是 novel/novel 这种格式，直接使用
        componentPath = URL
      }

      route['path'] = route['name'] = URL.replace(/\//g, '-')
      route['component'] = () => import(`@/views/modules/${componentPath}.vue`).catch(err => {
        console.error(`Failed to load component: @/views/modules/${componentPath}.vue`, err)
        return import('@/views/pages/404')
      })
    }
    routes.push(route)
  }
  if (temp.length >= 1) {
    return fnAddDynamicMenuRoutes(temp, routes)
  }

  // 添加路由
  router.addRoutes([
    {
      ...moduleRoutes,
      name: 'main-dynamic-menu',
      children: routes
    },
    { path: '*', redirect: { name: '404' } }
  ])
  window.SITE_CONFIG['dynamicMenuRoutes'] = routes
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = true
}

export default router
